import { render } from "./flash.vue?vue&type=template&id=28598f0a"
import script from "./flash.vue?vue&type=script&lang=js"
export * from "./flash.vue?vue&type=script&lang=js"

import exportComponent from "/appwd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__